import $ from "jquery";
import { debounce } from "../utils/debounce";

$.fn.select2.defaults.set("width", "100%");
$.fn.select2.defaults.set("theme", "irobot");
$.fn.select2.defaults.set("minimumResultsForSearch", 10);

$(".js-select2").select2();
$(".js-select2-check").select2({
  templateResult(state) {
    return $(`
      <span class="select2-check-result">
      <svg><use xlink:href="#button:circle_check-svg"></use></svg>
      ${state.text}
      </span>
    `);
  },
  templateSelection(state) {
    return $(`<span>${state.text}</span>`);
  }
});

$(".sideview__container").on(
  "scroll",
  debounce(function() {
    $(this)
      .find("select")
      .each(function() {
        const $select = $(this);
        if ($select.hasClass("select2-hidden-accessible")) {
          $select.select2("close");
        }
      });
  })
);
